import React from "react";
import {Box, IconButton, Stack, TextField, Button, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Add01Icon, Delete02Icon} from "@hugeicons/core-free-icons";

export const varsObjectToList = (vars) =>
  Object.entries(vars || {}).map(([key, value]) => ({key, value: String(value ?? "")}));

export const varsListToObject = (list) =>
  Object.fromEntries(
    (list || [])
      .map(({key, value}) => [key.trim(), value])
      .filter(([key]) => key.length > 0)
  );

export const VariablesEditor = ({rows, onChange}) => {
  const updateRow = (index, field, value) => {
    onChange(rows.map((row, i) => i === index ? {...row, [field]: value} : row));
  };

  const removeRow = (index) => {
    onChange(rows.filter((_, i) => i !== index));
  };

  const addRow = () => {
    onChange([...rows, {key: "", value: ""}]);
  };

  return (
    <Box>
      <Typography fontSize={11} fontWeight={700} textTransform="uppercase" letterSpacing={0.5} color="text.secondary" mb={0.75}>
        Variables
      </Typography>
      <Stack gap={1}>
        {rows.length === 0 && (
          <Typography fontSize={12} color="text.secondary" fontStyle="italic">No variables set.</Typography>
        )}
        {rows.map((row, index) => (
          <Stack key={index} direction="row" gap={1} alignItems="center">
            <TextField
              size="small" placeholder="Name" value={row.key}
              onChange={(e) => updateRow(index, "key", e.target.value)}
              InputProps={{sx: {fontFamily: "monospace", fontSize: 12}}}
              sx={{flex: 1}}
            />
            <TextField
              size="small" placeholder="Value" value={row.value}
              onChange={(e) => updateRow(index, "value", e.target.value)}
              InputProps={{sx: {fontFamily: "monospace", fontSize: 12}}}
              sx={{flex: 1}}
            />
            <IconButton size="small" color="error" onClick={() => removeRow(index)}>
              <HugeiconsIcon icon={Delete02Icon} size={16}/>
            </IconButton>
          </Stack>
        ))}
        <Box>
          <Button size="small" startIcon={<HugeiconsIcon icon={Add01Icon} size={14}/>} onClick={addRow}
                  sx={{textTransform: "none", fontSize: 12, color: "text.secondary"}}>
            Add Variable
          </Button>
        </Box>
      </Stack>
    </Box>
  );
};
